import { render, staticRenderFns } from "./update-log.vue?vue&type=template&id=1a59035e&scoped=true&"
import script from "./update-log.vue?vue&type=script&lang=js&"
export * from "./update-log.vue?vue&type=script&lang=js&"
import style0 from "./update-log.vue?vue&type=style&index=0&id=1a59035e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a59035e",
  null
  
)

export default component.exports